import React from 'react'

import { LoadingState } from '@sketch/components'

import { IndexLayoutHeader } from './IndexLayoutHeader'
import { Wrapper } from './IndexLayout.styles'

export const IndexLayoutLoading: React.FCC = () => (
  <Wrapper>
    <IndexLayoutHeader />
    <LoadingState />
  </Wrapper>
)
